export default "__VITE_ASSET__BUKp3pjV__"